<ion-header><bones-tt-page-header title="Test Grid (using cache)"></bones-tt-page-header></ion-header>

<ion-content class="ion-padding">

  <table class="bones-table" *ngIf="rows && rows.length > 0">
    <caption>Test Grid</caption>
    <thead>
      <tr>
        <th>Actions</th>
        <th>Timestamp</th>
        <th>Field 1</th>
        <th>Field 2</th>
        <th>Field 3</th>
        <th>Field 4</th>
        <th>Field 5</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let row of rows">
        <td>
          <ion-button small (click)="edit(row)">Edit</ion-button>
        </td>
        <td>{{row.converted | date}}</td>
        <td>{{row.info.FIELD1}}</td>
        <td>{{row.info.FIELD2}}</td>
        <td>{{row.info.FIELD3}}</td>
        <td>{{row.info.FIELD4}}</td>
        <td>{{row.info.FIELD5}}</td>
      </tr>
    </tbody>
  </table>

  <ion-card class="ion-padding" *ngIf="rows && rows.length === 0">
    <p>No items available.</p>
  </ion-card>
</ion-content>

<ion-footer>
  <ion-toolbar>
    <ion-buttons slot="end">
      <ion-button fill="solid" color="primary" (click)="edit()">Add</ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-footer>
